<template>
	<div id="dorm_scrollcenter">
		<div class="ctrd_list">
			<div class="d-flex jc-center">
				<Swiper class="swiper" :options="swiperOption" ref="chartSwiper" v-if="echartArr > 0">
					<Swiper-slide v-for="(dorm, index) in dormList" :key="index" :class="slidecss">
						<div class="ctrd_name">
							<img width="100%" height="100%" src="../../assets/img/dorm_icon.png">
							<span>{{ dorm.name }}</span>
						</div>
						<div :id="index" class="chart-container"></div>
						<div class="echarts_info">
							<div class="green">&#8226; 已入住<span>{{ dorm.num1 }}</span>人</div>
							<div class="yellow">&#8226; 未入住<span>{{ dorm.num2 }}</span>人</div>
						</div>
					</Swiper-slide>
				</Swiper>
			</div>
		</div>
	</div>
</template>

<script>
import HighCharts from 'highcharts';
var storage = window.localStorage;
var orgId = storage.getItem("orgId");
var buildIds = storage.getItem("buildIds");
import axios from 'axios';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper' // 导入组件
import "swiper/css/swiper.css"; // 导入样式
export default {
	components: {
		Swiper,
		SwiperSlide
	},
	data() {
		return {
			swiperOption: {},
			echartArr: 0,
			dormList: [],
			optionData: [],
			slidecss: ''
		}
	},
	mounted() {
		this.initData();
		// 定时器刷新，1小时
		let _this = this;
		this.interval1 = setInterval(() => {
			_this.initData();
		}, 1000 * 60 * 60);
	},
	beforeDestroy() {
		clearInterval(this.interval1);
		clearInterval(this.interval2);
	},
	methods: {
		swiperInit(size) {
			let _this = this;
			//初始化轮播组件属性
			if (size > 3) {
				_this.swiperOption = {
					notNextTick: true,
					observer: true, //修改swiper自己或子元素时，自动初始化swiper
					observeParents: true, //修改swiper的父元素时，自动初始化swiper
					slidesPerView: 3, //每页显示数量
					speed: 5000, //滑动速度
					loop: true, //循环轮播
					spaceBetween: 30, // 左右间距10
					autoplay: {
						delay: 3000,
						disableOnInteraction: false
					}
				}
			} else {
				_this.swiperOption = {
					slidesPerView: size,
					spaceBetween: 30, // 左右间距10
				}
				_this.slidecss = "swiper-slide-css";
				this.interval2 = setInterval(() => {
					document.getElementsByClassName('swiper-wrapper')[0].classList.add("swiper-wrapper-css");
				}, 100);
			}
		},
		initData() {
			//构建3d饼状图
			let _this = this;
			axios.get(this.$baseURL + '/dataView/dorm/floorCensus?orgId=' + orgId + "&buildIds=" + buildIds).then((res) => {
				var result = res.data.result;
				_this.echartArr = result.length;
				_this.dormList = [];
				for (let i = 0; i < result.length; i++) {
					var ratio1 = Math.round(result[i].liveCount / (result[i].totalCount) * 100);
					var ratio2 = Math.round(result[i].noLiveCount / (result[i].totalCount) * 100);
					_this.dormList.push(
						{
							"name": result[i].buildName,
							"ratio1": ratio1,
							"num1": result[i].liveCount,
							"ratio2": ratio2,
							"num2": result[i].noLiveCount
						}
					);
				}
				this.$nextTick(() => {
					var pieEcharts = document.getElementsByClassName('chart-container');
					for (let i = 0; i < pieEcharts.length; i++) {
						var index = pieEcharts[i].id;
						var dataParam = [];
						if (result[index].liveCount == 0 || result[index].noLiveCount == 0) {
							dataParam = [
								{ name: '已入住', sliced: false, color: '#00d587', y: result[index].liveCount },
								{ name: '未入住', sliced: false, color: '#ffc95d', y: result[index].noLiveCount }
							];
						} else {
							dataParam = [
								{ name: '已入住', sliced: true, color: '#00d587', y: result[index].liveCount },
								{ name: '未入住', sliced: false, color: '#ffc95d', y: result[index].noLiveCount }
							];
						}
						var option = {
							chart: {
								type: "pie", //饼图
								options3d: {
									enabled: true, //使用3d功能
									alpha: 25, //延y轴向内的倾斜角度
									beta: 0,
								},
								backgroundColor: 'rgba(255, 255, 255, 0)'
							},
							title: false,
							subtitle: false,
							credits: {
								enabled: false //不显示LOGO 
							},
							plotOptions: {
								pie: {
									allowPointSelect: true, //每个扇块能否选中
									cursor: "pointer", //鼠标指针
									depth: 25, //饼图的厚度
									dataLabels: {
										enabled: false,
										style: {
											color: '#000',
											fontSize: "15px",
											fontWeight: '600',
											textOutline: "none", // 去除黑色阴影
										}
									}
								}
							},
							series: [{
								type: "pie",
								name: '人数',
								size: '75%',
								dataLabels: {
									formatter: function () {
										return this.point.percentage > 0 ? HighCharts.numberFormat(this.point.percentage, 0) + "%" : null;
									},
									distance: -30
								},
								data: dataParam
							}]
						}
						HighCharts.chart(pieEcharts[i], option)
					}
				})
				this.swiperInit(result.length); //初始化轮播组件
			}).catch((error) => {
				console.log(error);
			})
		}
	}
}
</script>

<style lang="scss">
#dorm_scrollcenter {
	height: 100%;

	.ctrd_list {
		width: 12.5rem;
	}

	.swiper-container {
		width: 100%;
	}

	.swiper-wrapper {
		transition-timing-function: linear !important;
		transform: translate3d(-AAApx, 0px, 0px) !important;
	}

	.swiper-wrapper-css {
		display: flex;
		justify-content: center;
	}

	.swiper-slide-css {
		width: 30% !important;
	}

	.swiper-slide {
		box-shadow: inset 0px 0px 0.15rem 0.1rem rgba(0, 102, 128, 0.8);
		border-radius: 0.15rem;
		padding: 0.3rem 0;
		height: 36.5vh;
	}

	.ctrd_name {
		text-align: center;
		font-size: 0.25rem;
		line-height: 0.25rem;
		font-weight: bold;
		color: #00f0ff;
		overflow: hidden;
		width: 80%;
		margin: 0 auto;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.ctrd_name img {
		width: 0.35rem;
		vertical-align: sub;
		margin-right: 0.05rem;
	}

	.chart-container {
		width: 90%;
		height: 70%;
		margin: 0 auto;
		overflow: hidden;
	}

	.echarts_info {
		width: 2rem;
		margin: 0 auto;
		text-align: left;
		font-size: 0.25rem;
	}

	.echarts_info .yellow {
		margin-top: 0.1rem;
	}

	.echarts_info span {
		//color: #00f0ff;
		margin: 0 5px;
	}
}
</style>
